import Vue from 'vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

Vue.filter('toLongDate', str =>
  dayjs
    .utc(str)
    .local()
    .format('YYYY[.]MM[.]DD HH:mm:ss [(UTC]Z[)]')
);
